'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Networks } from 'AdsUI/lib/Constants';
import { fetchTrackingStatusesForAd } from 'AdsUI/data/TrackingStatusData';
import useTrackingErrorModal from 'AdsUI/lib/useTrackingErrorModal';
import BaseTrackingErrorModal from 'AdsUI/components/tracking-error-modal/BaseTrackingErrorModal';

const AdTrackingErrorModal = ({
  accountId,
  adGroupId,
  adId,
  campaignId,
  name,
  network,
  onClose
}) => {
  const fetchStatuses = useCallback(() => fetchTrackingStatusesForAd(network, accountId, campaignId, adGroupId, adId), [network, accountId, campaignId, adGroupId, adId]);
  const {
    loading,
    groupedStatuses
  } = useTrackingErrorModal(fetchStatuses);
  return /*#__PURE__*/_jsx(BaseTrackingErrorModal, {
    onClose: onClose,
    groupedStatuses: groupedStatuses,
    loading: loading,
    name: name
  });
};

AdTrackingErrorModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  adGroupId: PropTypes.string.isRequired,
  adId: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  name: PropTypes.string,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  onClose: PropTypes.func.isRequired
};
export default AdTrackingErrorModal;